<template>
  <el-dialog title="选择资质" :visible.sync="_visible" width="720px">

    <el-row :gutter="20">
        <el-col :span="6" v-for="(item,index) in dataSource" :key="index">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
                <img :src="item.url" class="image">
                <div style="padding: 14px;">
                    <el-button type="text" plain class="button" style="width: 100%;" @click="handleSelected(item)">选择</el-button>
                </div>
            </el-card>
        </el-col>
    </el-row>

  </el-dialog>
</template>

<script>
  import moment from "moment";
  import PaginationChange from '../../mixins/PaginationChange.vue'
  export default {
    mixins: [PaginationChange],
    props: {
      visible: {
        default: false,
        type: Boolean
      },
      order_id:{},
      taxonomy: {
        default: '',
        type: String
      },
    },
    data() {
      return {
        dataSource: [],
        value: "",
        date: "",
        pagination: {
          total: 0,
          per_page: 20,
          current_page: 0
        }
      };
    },
    computed: {
      _visible: {
        get() {
          return this.visible
        },
        set() {
          this.$emit('dialogHidden')
        }
      }
    },
    created() {
      this.load();
    },
    methods: {
      load() {
        
        this.$http.get("/personal/certificate").then(response => {
          if (response.success) {
            this.dataSource = response.data;

            this.pagination = response.pagination;
          }
        })
      },
      handleSelected(v){
          this.$emit('certSelected',v)
          this.$emit('dialogHidden')
      },
      handleCurrentChange(e) {
        this.pagination.current_page++;
        this.load()
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/manuscript/Certificate.vue